module.exports = __webpack_public_path__ + "img/gzh_qrcode.9b9ea030.jpg";